export const DEFAULT_ENTITY_AUTHOR = ' Leonardo DaVinci';

export const ENGLISH_LEVEL_SHORT = {
  A1: 'A1',
  A2: 'A2',
  B1: 'B1',
  B2: 'B2',
  C1: 'C1',
  C2: 'C2',
};

export const ENGLISH_LEVEL_SHORT_OPTIONS = {
  [ENGLISH_LEVEL_SHORT.A1]: 'A1',
  [ENGLISH_LEVEL_SHORT.A2]: 'A2',
  [ENGLISH_LEVEL_SHORT.B1]: 'B1',
  [ENGLISH_LEVEL_SHORT.B2]: 'B2',
  [ENGLISH_LEVEL_SHORT.C1]: 'C1',
  [ENGLISH_LEVEL_SHORT.C2]: 'C2',
};

export const CURRENCY_TYPES = {
  USD: 'USD',
  EUR: 'EUR',
  BYN: 'BYN',
  PLN: 'PLN',
};

// roles
export const SERVICE_ENGINEER_POSTFIX = '_SE';
export const SERVICE_MANAGER_POSTFIX = '_SM';

export const enum Role {
  // C level
  CEO = 'CEO',
  CFO = 'CFO',
  CTO = 'CTO',
  COO = 'COO',

  // Employee roles
  EMPLOYEE = 'EMPLOYEE',

  // Managers
  EDUCATION_MANAGER = 'EDUCATION_MANAGER',
  HR_MANAGER = 'HR_MANAGER',

  // Others
  LEAD_RECRUITER = 'LEAD_RECRUITER',
  VP_OF_SALES = 'VP_OF_SALES',
  MARKETER = 'MARKETER',
  RECRUITER = 'RECRUITER',
  PRESALE_COORDINATOR = 'PRESALE_COORDINATOR',
  MARKETING_MANAGER = 'MARKETING_MANAGER',
  PEOPLE_MANAGER = 'PEOPLE_MANAGER',
  DELIVERY_MANAGER = 'DELIVERY_MANAGER',
  // Ignore (IGNORE_ON_FE / CompanyRolesInput)
  COMPANY_STAFFING_COORDINATOR = 'COMPANY_STAFFING_COORDINATOR',
  COMPANY_VACANCY_MANAGER = 'COMPANY_VACANCY_MANAGER',
  EMPLOYEE_MENTOR = 'EMPLOYEE_MENTOR',
  EVENT_MANAGER = 'EVENT_MANAGER',
  PERFORMANCE_REPORT_REVIEWER = 'PERFORMANCE_REPORT_REVIEWER',
  TIMELINE_MANAGER = 'TIMELINE_MANAGER',

  // Service managers
  ASSIGNMENT_MANAGEMENT_SM = 'ASSIGNMENT_MANAGEMENT_SM',
  EDUCATION_SM = 'EDUCATION_SM',
  EMPLOYEE_MANAGEMENT_SM = 'EMPLOYEE_MANAGEMENT_SM',
  FINANCE_SM = 'FINANCE_SM',
  IDENTITY_MANAGEMENT_SM = 'IDENTITY_MANAGEMENT_SM',
  IT_SM = 'IT_SM',
  LEGAL_SM = 'LEGAL_SM',
  OFFICE_MANAGEMENT_SM = 'OFFICE_MANAGEMENT_SM',
  PROCESS_SUPPORT_SM = 'PROCESS_SUPPORT_SM',
  PROJECT_MANAGEMENT_OFFICE_SM = 'PROJECT_MANAGEMENT_OFFICE_SM',
  RESOURCE_MANAGEMENT_SM = 'RESOURCE_MANAGEMENT_SM',
  SECURITY_SM = 'SECURITY_SM',

  // Service engineers
  ASSIGNMENT_MANAGEMENT_SE = 'ASSIGNMENT_MANAGEMENT_SE',
  EDUCATION_SE = 'EDUCATION_SE',
  EMPLOYEE_MANAGEMENT_SE = 'EMPLOYEE_MANAGEMENT_SE',
  FINANCE_SE = 'FINANCE_SE',
  IDENTITY_MANAGEMENT_SE = 'IDENTITY_MANAGEMENT_SE',
  IT_SE = 'IT_SE',
  LEGAL_SE = 'LEGAL_SE',
  OFFICE_MANAGEMENT_SE = 'OFFICE_MANAGEMENT_SE',
  PROCESS_SUPPORT_SE = 'PROCESS_SUPPORT_SE',
  PROJECT_MANAGEMENT_OFFICE_SE = 'PROJECT_MANAGEMENT_OFFICE_SE',
  RESOURCE_MANAGEMENT_SE = 'RESOURCE_MANAGEMENT_SE',
  SECURITY_SE = 'SECURITY_SE',
}

export const PROJECT_MEMBERSHIP_ROLES = {
  PROJECT_MANAGER: 'Project Manager',
  QA_MANAGER: 'QA Manager',
  TEAM_LEAD: 'Team Lead',
  BUSINESS_ANALYST: 'Business Analyst',
  ARCHITECT: 'Architect',
  SOFTWARE_ENGINEER: 'Software Engineer',
  MANUAL_QA_ENGINEER: 'Manual QA Engineer',
  UI_UX_DESIGNER: 'UI/UX Designer',
  INTERN: 'Intern',
  ACCOUNT_MANAGER: 'Account Manager',
};
export type ProjectMembershipRole = keyof typeof PROJECT_MEMBERSHIP_ROLES;

export const PROJECT_MEMBERSHIP_ROLES_KEY: Record<ProjectMembershipRole, ProjectMembershipRole> = {
  PROJECT_MANAGER: 'PROJECT_MANAGER',
  QA_MANAGER: 'QA_MANAGER',
  TEAM_LEAD: 'TEAM_LEAD',
  BUSINESS_ANALYST: 'BUSINESS_ANALYST',
  ARCHITECT: 'ARCHITECT',
  SOFTWARE_ENGINEER: 'SOFTWARE_ENGINEER',
  MANUAL_QA_ENGINEER: 'MANUAL_QA_ENGINEER',
  UI_UX_DESIGNER: 'UI_UX_DESIGNER',
  INTERN: 'INTERN',
  ACCOUNT_MANAGER: 'ACCOUNT_MANAGER',
};

export const PRIVATE_MEMBERSHIP_ROLES: ProjectMembershipRole[] = [
  PROJECT_MEMBERSHIP_ROLES_KEY.PROJECT_MANAGER,
  PROJECT_MEMBERSHIP_ROLES_KEY.TEAM_LEAD,
];

export const EMPLOYEE_DOCUMENT_HR_TYPES_VALUES = {
  EMPLOYMENT: 'Employment',
  DISMISSAL: 'Dismissal',
  LEAVE: 'Leave',
  CONTRACT_EXTENSION: 'Contract extension',
  EMPLOYEE_CONFIDENTIALITY_COMPLIANCE: 'Employee Confidentiality & Compliance',
  OTHER: 'Other Employee Agreements',
};

export enum NumberFieldType {
  INTEGER = 'INTEGER',
  DOUBLE = 'DOUBLE',
}

export const DoubleValueFormat = /^\d+(\.?)(\d{0,2})$/;
export const IntegerValueFormat = /^\d+$/;
